import { theme } from 'config';

const pallet = {
  mainButton: '#3B53A7',
  primary1Color: '#3B53A7',
  titleColor: '#1D1C1E',
  subtitleColor: '#A39FA8',
  dividerColor: '#F6F6F6',
  loginColor: '#3B53A7',
  appBarColor: 'white',
  appBarTextColor: '#1D1C1E',
  appBarTextColorHint: '#A39FA8',
  errorColor: '#E06255',
  warningColor: '#ECC651',
  infoColor: '#859DEE',
  successColor: '#4D8F5F',
  grey: '#A39FA8',
  // Customer theme colors override the defaults here
  ...theme,
};

export default pallet;



// WEBPACK FOOTER //
// ./src/constants/colors.js